import { useState, useSyncExternalStore } from "react";
import { TpvDialog } from "./TpvDialog";
import {
  subscribeProductSync,
  getProductSyncSnapshotVersion,
  getPausedProductChanges,
  retryPausedProductChanges,
  discardPausedProductChanges,
} from "../services/productSyncQueue";
import "./productSyncNotice.css";
export const ProductSyncNotice = () => {
  useSyncExternalStore(
    subscribeProductSync,
    getProductSyncSnapshotVersion,
    getProductSyncSnapshotVersion,
  );
  const groups = getPausedProductChanges();
  const [open, setOpen] = useState(false),
    [busy, setBusy] = useState(false),
    [error, setError] = useState(""),
    [discard, setDiscard] = useState(null);
  if (!groups.length) return null;
  const act = async (group, remove) => {
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      if (remove) await discardPausedProductChanges(group.resourceKey);
      else if (!(await retryPausedProductChanges(group.resourceKey)))
        throw Error(
          "No se pudo confirmar el guardado. Los cambios siguen conservados.",
        );
      setDiscard(null);
      if (!getPausedProductChanges().length) setOpen(false);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <aside className="tpvSyncNotice" role="status">
        <span>
          Hay cambios pendientes de revisar. No se enviarán automáticamente.
        </span>
        <button type="button" onClick={() => setOpen(true)}>
          Revisar cambios
        </button>
      </aside>
      {open && (
        <TpvDialog
          title="Cambios pendientes"
          busy={busy}
          onClose={() => {
            setOpen(false);
            setDiscard(null);
            setError("");
          }}
          className="tpvSyncReview"
        >
          <div className="tpvDialogBody">
            <p>
              Estos cambios se conservan en este dispositivo. No se aplicarán a
              una venta diferente.
            </p>
            {error && <p role="alert">{error}</p>}
            {groups.map((group, i) => (
              <section key={group.resourceKey}>
                <h3>
                  {group.resourceKey.startsWith("order:") ? "Pedido" : "Cesta"}{" "}
                  pendiente {i + 1}
                </h3>
                <ul>
                  {group.lines.map((line) => (
                    <li key={line.key}>
                      {line.quantity} × {line.name}
                    </li>
                  ))}
                </ul>
                <p>{group.message}</p>
                {discard === group.resourceKey ? (
                  <div>
                    <p>
                      ¿Descartar estos cambios del dispositivo? No se borrará ni
                      modificará el pedido o la cesta guardados. Revisa antes su
                      historial para comprobar qué se guardó.
                    </p>
                    <button
                      type="button"
                      disabled={busy}
                      onClick={() => act(group, true)}
                    >
                      Descartar del dispositivo
                    </button>
                    <button
                      type="button"
                      disabled={busy}
                      onClick={() => setDiscard(null)}
                    >
                      Conservar cambios
                    </button>
                  </div>
                ) : (
                  <div>
                    <button
                      type="button"
                      disabled={busy || group.running}
                      onClick={() => act(group, false)}
                    >
                      {busy ? "Comprobando…" : "Comprobar y reintentar"}
                    </button>
                    <button
                      type="button"
                      disabled={busy || group.running}
                      onClick={() => setDiscard(group.resourceKey)}
                    >
                      Descartar cambios…
                    </button>
                  </div>
                )}
              </section>
            ))}
          </div>
        </TpvDialog>
      )}
    </>
  );
};
